import axios from "axios";
import userServices, { AUTH_BASE_URL } from "./UserServices";

const httpConfig = {
	baseURL: process.env.REACT_APP_BACKEND_URL
};

const httpInstance = axios.create(httpConfig);

httpInstance.interceptors.request.use(async config => {
	const { url } = config;
	if (typeof url === "string") {
		if (!url.startsWith(AUTH_BASE_URL) && !url.includes("config")) {
			const token = await userServices.getAccessToken();
			config.headers = {
				...config.headers,
				Authorization: `Bearer ${token}`
			};
		}
		return config;
	} else throw new Error("Invalid URL");
});

httpInstance.interceptors.response.use(
	res => {
		if (res?.data?.data) {
			return Promise.resolve(res.data.data);
		} else return Promise.resolve(res);
	},
	error => {
		if (error?.response?.data) {
			return Promise.reject(error.response.data);
		} else return Promise.reject(error);
	}
);

const http = { get: httpInstance.get, post: httpInstance.post, httpInstance };

export default http;
